import {chartsApiUrl, isServer} from "../web/src/common/app/read_charts_web_environment_variables";

//  Absolute urls are required for the server (no origin available)
export const getBigDataApiPath = () => {
    return isServer ? `${chartsApiUrl}/api/` : "/api/";
};
